module.exports = __webpack_public_path__ + "static/media/happy200h.988e5783.png";